import { IAudienceMetaRecord } from '@/Interfaces/Audiences/Audience.interface';
import { memo } from 'react';
import AudienceOrGroup from './AudienceOrGroup';

interface IProps {
  andGroups: IAudienceMetaRecord[][];
}

const AudienceAndGroups = memo(({ andGroups }: IProps) => {
  if (andGroups.length === 1) {
    return <AudienceOrGroup orGroup={andGroups[0]} />;
  }

  return (
    <div>
      {andGroups.map((orGroups, index) => {
        return (
          <div key={index}>
            <AudienceOrGroup orGroup={orGroups} />
            {index !== andGroups.length - 1 && <p className='text-[#0C3]'>AND</p>}
          </div>
        );
      })}
    </div>
  );
});

export default AudienceAndGroups;
